"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const text_1 = require("../text");
const TextArea = props => {
    const isSmallScreen = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("sm"));
    return (0, jsx_runtime_1.jsx)(text_1.TextInput, { multiline: true, minRows: isSmallScreen ? 2 : 5, maxRows: Infinity, ...props });
};
exports.TextArea = TextArea;
//# sourceMappingURL=index.js.map